<template>
  <div class="input-slider">
    <div class="input-slider-label flex-row flex-gap-small flex-center-v">
      <label :for="$attrs.id" v-html="`${label} :`"></label>
      <output :for="$attrs.id" class="border-alert-success" v-if="!displayValue">{{ _value }}</output>
      <output :for="$attrs.id" class="border-alert-success" v-else>{{ displayValue }}</output>
    </div>

    <span class="hint" v-if="hint" v-html="hint"></span>

    <div class="range-slider">
      <span class="label label--before" v-if="before || $attrs['data-display-range']">
        <div v-if="$attrs['data-display-range'] && $attrs?.min">
          {{ $attrs.min }}<span v-if="$attrs['data-units']"> {{ $attrs["data-units"] }}</span>
        </div>
        <span v-if="before" v-html="before"></span>
      </span>

      <div class="range-wrapper">
        <input type="range" v-bind="$attrs" v-model="_value" :title="_value" step="0.5" />

        <div class="label label--middle">
          <!-- <span v-if="$attrs['data-display-range'] && $attrs?.max">{{ ($attrs.max / 2) }}</span> -->
          <span v-if="middle" v-html="middle"></span>
        </div>
      </div>

      <span class="label label--after" v-if="after || $attrs['data-display-range']">
        <div v-if="$attrs['data-display-range'] && $attrs?.max">
          {{ $attrs.max }}<span v-if="$attrs['data-units']"> {{ $attrs["data-units"] }}</span>
        </div>
        <span v-if="after" v-html="after"></span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "RangeInput",
  inheritAttrs: false,
  props: ["value", "label", "displayRange", "before", "after", "middle", "hint", "displayValue", "show"],

  computed: {
    // Model for the value prop of the component
    _value: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.input-slider {
  display: flex;
  flex-flow: column wrap;
  gap: 1rem;

  // label {
  // 	font-weight: 500;
  // }

  output {
    border: 1px solid #d8d8d8;
    border-radius: 3px;
    font-variant-numeric: tabular-nums;
    min-width: 2.5em;
    padding: 0.25rem 0.5rem;
    text-align: center;
  }

  .label {
    color: #363636;
    align-items: center;
    display: flex;
    flex-flow: column wrap;
    // flex-basis: 20%;
    font-size: 0.875rem;
    gap: 0.5em;
    justify-content: space-evenly;
    text-align: center;
  }

  .label.label--middle {
    position: absolute;
    left: 50%;
    bottom: -1em;
    transform: translateX(-50%);
  }

  .range-slider {
    align-items: stretch;
    display: flex;
    flex-flow: row wrap;
    gap: 1rem;
    justify-content: center;

    // padding: 0.25em .5em;
    // border-radius: .25em;
    // border: 1px solid #dedede;

    .range-wrapper {
      flex: 1;
      position: relative;
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;

      [type="range"] {
        min-width: 6em;
      }
    }
  }

  &.stripes-10 .range-wrapper::before {
    content: "";
    display: flex;
    background: repeating-linear-gradient(90deg, #ccc, #ccc 1px, transparent 1px, transparent 10%);
    background-position: center;
    background-size: 100%;
    background-repeat: no-repeat;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0.65rem;
    right: 0.65rem;
    margin: 0;
    z-index: -1;
    height: 50%;
    padding: 0;
  }
}
</style>
